import React from "react";
import Navbar from "../../components/Navbar";
import ListPF from "../../components/ListPF";
import PessoaFisica from "../../assets/navbar/Pessoa_fisica_on_light_blue.svg";
import { ImPlus } from "react-icons/im";
import * as S from "./styles";

import { useHistory, useLocation } from "react-router-dom";

export default function PFList() {
  const history = useHistory();
  const params = useQuery();

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  return (
    <>
      <Navbar />
      <S.Wrapper>
        <S.Header>
          <S.BoxUser>
            <S.Image src={PessoaFisica} />
            <div>
              <S.Title>Pessoa Física</S.Title>
              <S.Description>Cadastro geral de pessoa física</S.Description>
            </div>
          </S.BoxUser>

          <S.AddNew onClick={() => history.push("/cadastro-pessoa-fisica")}>
            <ImPlus
              style={{
                margin: "0px 0px 30px",
              }}
            />
            <S.Image src={PessoaFisica} />
          </S.AddNew>
        </S.Header>

        <ListPF
          filter={params.get("filter") || ""}
          pageFilter={parseInt(params.get("page") || "0")}
          history={history}
        />
      </S.Wrapper>
    </>
  );
}
